// Available fields for the Truck (Operator) Request report config
// (ids must match the columns the Truck Operator Request List export already renders).
const trkOpReqReptFieldsArr = [
    { id: "truckOpReqId", label: "Request Id", minWidth: 100 },
    { id: "name", label: "Truck Operator", minWidth: 100 },
    { id: "currLocation", label: "Current Location", minWidth: 120 },
    { id: "routes", label: "Route", minWidth: 120 },
    { id: "availSpace", label: "Available Space", minWidth: 100 },
    { id: "regNo", label: "Truck Number", minWidth: 100 },
    { id: "truckTypes", label: "Truck Type", minWidth: 100 },
    { id: "createdShipmtCount", label: "Created Shipments", minWidth: 50 },
    { id: "c_at", label: "Posted On", minWidth: 100 },
];

export default trkOpReqReptFieldsArr;
